// @flow

import React, { useState, useEffect } from 'react'
import PT from 'prop-types'
import logger from '@vimcar/shared-utils/logger'
import FullscreenMessage from '@vimcar/shared-components/components/FullscreenMessage'
import Loader from '@vimcar/shared-components/components/Loader'

import ShiftmoveIntegrationInfo from '#components/ShiftmoveIntegrationInfo'

import styles from './styles.css'
import i18n from '#utils/i18n'

const tp = i18n.prefix('components.ShiftmoveIntegrationCheck')
type Props = {
  children: any,
  routeContext?: string,
}

const ShiftmoveIntegrationCheck = ({ children, routeContext }: Props, context: any) => {
  const [platformIntegrationEnabled, setIntegrationEnabled] = useState<?boolean>(null)
  const [configurationLoading, setConfigurationLoading] = useState(true)
  const [hasError, setHasError] = useState(false)

  useEffect(() => {
    if (context.domain && context.domain.currentDomain && context.domain.currentDomain.configuration) {
      const subscription = context.domain.currentDomain.configuration.get().subscribe({
        next: (configuration) => {
          const enabled = configuration && 
            configuration.platform && 
            configuration.platform.driverIdentificationPlatform === true
          setIntegrationEnabled(enabled)
          setConfigurationLoading(false)
        },
        error: (error) => {
          setHasError(true)
          setConfigurationLoading(false)
          logger.error(error)
        }
      })

      return () => {
        if (subscription && subscription.unsubscribe) {
          subscription.unsubscribe()
        }
      }
    } else {
      throw new Error('ShiftmoveIntegrationCheck: Domain context is not available - cannot determine access permissions')
    }
  }, [context.domain])

  if (configurationLoading) {
    return <div className={styles.loaderContainer}><Loader/></div>
  }

  if (hasError) {
    return <FullscreenMessage title={tp('loading-failed')}/>
  }

  if (platformIntegrationEnabled) {
    return <ShiftmoveIntegrationInfo routeContext={routeContext} />
  }

  return children
}

ShiftmoveIntegrationCheck.contextTypes = {
  domain: PT.object,
}

export default ShiftmoveIntegrationCheck
